import React from 'react';

function asFunctional<P extends React.JSX.IntrinsicAttributes & React.JSX.IntrinsicClassAttributes<React.Component<P, S, any>> & Readonly<P>, S> (WrappedComponent: React.ComponentClass<P, S>) {
  return (props: P) => <WrappedComponent {...props} />;
}

export default asFunctional;